import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoMultiViewCalendarMixin from './KendoMultiViewCalendarMixin'

export default {
    name: 'kendo-multiviewcalendar',
    mixins: [ KendoMultiViewCalendarMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('div')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoMultiViewCalendar/index.js